/**
 * DashboardEnhancedPage - Enhanced dashboard with production features
 *
 * Surfaces the DashboardEnhanced from @ferp/workflow-forms for admin/architect users.
 * Provides production-ready dashboard with real-time metrics and alerts.
 *
 * Route: /admin/dashboard-enhanced
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconLayoutDashboard } from '@tabler/icons-react';

import { DashboardEnhanced } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function DashboardEnhancedPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="indigo">
            <IconLayoutDashboard size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Enhanced Dashboard</Title>
            <Text size="sm" c="dimmed">
              Production-ready dashboard with real-time metrics and alerts
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <DashboardEnhanced />
    </Container>
  );
}

export default DashboardEnhancedPage;
